export const commonCountries = ['DE', 'CH', 'AT', 'US', 'GB', 'FR', 'RU'];

export const continentSort = ['europe', 'oceania', 'asia', 'africa', 'america'];
